import { h } from 'preact';
import Helmet from 'preact-helmet';
import { useSelector } from 'react-redux';

import { getHref } from 'core/universalRouter/Link';
import { SeoData } from 'Seo-Types';

import { LANGUAGE_CODE } from 'constants/common';

import { getBaseUrl, getHost, getProtocol } from 'store/__router/selectors';

const SEO = (props: SeoData) => {
  const host = useSelector(getHost);
  const baseUrl = useSelector(getBaseUrl);
  const protocol = useSelector(getProtocol);
  const {
    title,
    description,
    keywords,
    imageUrl,
    isIndexablePage = false,
    canonicalPath,
    isDynamicUrl = false,
  } = props;
  const url = getHref(host + baseUrl, canonicalPath, protocol);
  const metaContents = [
    { name: 'description', content: description },
    { property: 'og:description', content: description },
    { property: 'og:type', content: 'article' },
    { property: 'og:title', content: title },
  ];

  if (!isDynamicUrl) {
    if (imageUrl) metaContents.push({ property: 'og:image', content: imageUrl });
    if (keywords) metaContents.push({ name: 'keywords', content: keywords?.join(',') });
    metaContents.push({ property: 'og:url', content: url });
  }

  if (!isIndexablePage) {
    metaContents.push({
      name: 'robots',
      content: 'noindex, nofollow, noarchive',
    });
  }

  const linkContents = canonicalPath ? [{ rel: 'canonical', href: url }] : [];

  return (
    <Helmet
      htmlAttributes={{ lang: LANGUAGE_CODE, amp: undefined }}
      title={title}
      meta={metaContents}
      link={linkContents}
    />
  );
};

export default SEO;
